module.exports = __webpack_public_path__ + "static/media/index.1d51d54.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mapVideos/zhejiang/index.mp4
// module id = Bqrj
// module chunks = 6